import { getAccessTokenFromLocalStorage } from 'app/utils/localStorage';
import { path } from 'app/utils/path';
import React, { FunctionComponent } from 'react';
import { Redirect, Route } from 'react-router-dom';

interface Props {
  component: any;
  rest: Array<any>;
}

const AuthRoute: FunctionComponent<any> = ({
  component: Component,
  ...rest
}) => {
  const isAuth: string | null = getAccessTokenFromLocalStorage();
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuth ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: path.auth.SIGN_IN,
            }}
          />
        )
      }
    />
  );
};

export default AuthRoute;
